import { Observable } from 'rxjs';
import { VirusScanStatus } from './document-reference.model';

// type of docNode 1 = file, 50 = directory
export enum DocNodeTypes {
  File = 1,
  Directory = 50,
}

export interface DocNode {
  pid?: string;
  tp: DocNodeTypes;
  // name used for folders
  name?: string;
  // desc used for files
  desc?: string;
  path?: string;
  kds?: DocNode[];
  documentType?: string;
  refId?: string;
  exts?: string[];
  fileName?: string;
  fileType?: string;
  size?: number;
  vsts?: VirusScanStatus;
  uploadObs?: Observable<any>;
  _id: string;
  origfl?: string;
}

/**
 * Client-side lifecycle of an in-flight upload — FE-only, never sent to or
 * received from the server. Distinct from `DocumentStatus`
 * (`document-reference.model.ts`), which is the server's lifecycle for the
 * file behind a reference.
 */
export enum DocumentUploadStatus {
  CREATED = 'CREATED',
  STARTED = 'STARTED',
  COMPLETED = 'COMPLETED',
  PLACEHOLDER = 'PLACEHOLDER',
  CANCELED = 'CANCELED',
  /** The token request or the byte upload itself errored — distinct from `CANCELED` (a user action) so the UI can surface it instead of silently dropping the row. */
  FAILED = 'FAILED',
}
